import {
	ExpandMoreRounded,
	KeyboardArrowRightRounded
} from '@mui/icons-material';
import {
	alpha,
	Box,
	Button,
	Link,
	MenuItem,
	Select,
	Skeleton,
	Typography
} from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SetSelectedComputeProfileObj } from '../../../../Redux/Action/computeAction';
import quantum1 from '../../../../assets/images/quantum1.webp';
import quantum8 from '../../../../assets/images/quantum8.png';

function LaunchBar({ billing, handleLaunchLab, isSubmitting }) {
	const { computeProfile, selectedProfileObj } = useSelector(
		(state) => state.computeReducer
	);
	const dispatch = useDispatch();

	const onChangeComputeHandler = (event) =>
		dispatch(
			SetSelectedComputeProfileObj(
				computeProfile.find((item) => item?.display_name === event.target.value)
			)
		);

	return (
		<Box
			className="appBar-mid__activeplan-container"
			cy-data="launcher-bar"
			sx={{
				position: { xs: 'absolute', md: 'relative' }
			}}
		>
			<Link
				href="/subscription"
				sx={{ textDecoration: 'none', display: { xs: 'none', sm: 'block' } }}
				py={0.5}
				pr={2.5}
			>
				<Typography
					className="nunito-style-bold"
					color="text.primary"
					cy-data="lab-launcher-plan"
				>
					{billing?.activePlanName || <Skeleton width={75} />}
				</Typography>
			</Link>
			<Select
				variant="standard"
				value={selectedProfileObj?.display_name}
				IconComponent={ExpandMoreRounded}
				onChange={onChangeComputeHandler}
				sx={{ fontSize: 14, display: { xs: 'none', sm: 'flex' } }}
				MenuProps={{
					disableScrollLock: true,
					MenuListProps: {
						sx: {
							padding: 1.5,
							maxHeight: 200,
							overflow: 'auto'
						}
					},
					sx: {
						'& .MuiMenu-paper': {
							borderRadius: '10px !important'
						}
					}
				}}
				disableUnderline
				renderValue={() => (
					<Typography
						variant="body2"
						fontSize={14}
						sx={{
							maxWidth: {xs:'auto', md:'100px'},
							overflow: 'hidden',
							whiteSpace: 'nowrap',
							textOverflow: 'ellipsis'
						}}
						color="text.primary"
					>
						{selectedProfileObj?.display_name}
					</Typography>
				)}
				cy-data="lab-launcher-list"
			>
				{computeProfile?.map((item, _index) => (
					<MenuItem
						sx={{
							padding: '0',
							display: 'flex',
							gap: '1em',
							borderRadius: '5px'
						}}
						key={item?.display_name}
						value={item?.display_name}
						title={item?.display_name}
						cy-data="lab-launcher-list-item"
					>
						<Box
							sx={{
								borderRadius: '2px',
								minWidth: '40px',
								maxWidth: '40px'
							}}
						>
							<img
								src={item?.display_name.includes('GPU') ? quantum8 : quantum1}
								width="100%"
								height="100%"
								alt="qImg"
								style={{ objectFit: 'contain' }}
							/>
						</Box>
						<Typography
							variant="body2"
							sx={{
								// maxWidth: '100px',
								overflow: 'hidden',
								whiteSpace: 'nowrap',
								textOverflow: 'ellipsis'
							}}
						>
							{item?.display_name || 0}
						</Typography>
					</MenuItem>
				)) || <Skeleton width={75} />}
			</Select>
			<Button
				variant="slide"
				onClick={handleLaunchLab}
				disabled={isSubmitting}
				title="Launch qLab"
				cy-data="lab-launcher"
				fullWidth
				endIcon={<KeyboardArrowRightRounded />}
				sx={(theme) => ({
					fontFamily: theme.typography.fontFamily,
					fontSize: 14,
					fontWeight: 900,
					boxShadow: `0 10px 25px -5px ${alpha(theme.palette.primary.main, 0.41)}, 0 8px 10px -6px ${alpha(theme.palette.primary.main, 0.20)}`,
					':hover': {
						transform: 'scale(1.05)',
						boxShadow: theme.shadows[16],
						textShadow: '0 0 6px rgba(255, 255, 255, 0.5)'
					}
				})}
			>
				Launch Lab
			</Button>
		</Box>
	);
}

export default LaunchBar;
